<template>
	<v-container fluid fill-height
		><v-row>
			<v-col cols="12" md="6">
				Your IP:
				<v-text-field
					label="Your Internet Address (ipv4)"
					placeholder="Placeholder"
					filled
					v-model="info"
				></v-text-field>

				<v-text-field
					label="Your Internet Address (ipv6)"
					placeholder="Placeholder"
					filled
					v-model="info_v6"
				></v-text-field>
			</v-col>
		</v-row>
	</v-container>
</template>
<script>
import axios from "axios";
export default {
	data: function() {
		return {
			info: "Loading",
			info_v6: "Loading"
		};
	},

	mounted() {
		axios.get("https://api.ipify.org/?format=json").then(response => {
			this.info = response.data.ip;
		});
		axios.get("https://api6.ipify.org/?format=json").then(response => {
			this.info_v6 = response.data.ip;
		});
	}
};
</script>
